import { useSelector } from 'react-redux';
import { TableRow, TableCell } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { formatBalanceUi } from '@utils/balance-helpers';
import { useReferralInfoDialog } from '@utils/dialogs-hooks';
import { formatMonth } from '@utils/date-helpers';
import { theme } from '@utils/libs/theme';
import { referralsColumns } from '@utils/tables/columns';
import ReferralDaysLeft from '@widgets/referrals/ReferralDaysLeft';
import { CustomTable, CustomTableMobile } from '@widgets/tables/main';

function ReferralRevenue({ row }) {
  return (
    <p className="positive-num">{formatBalanceUi(row.totalRevenue, 'USD')}</p>
  );
}

export default function ReferralsTable({ search }) {
  const { referrals, isLoading } = useSelector((state) => state.referrals);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { openReferralInfoDialog } = useReferralInfoDialog();

  const query = search.trim().toLowerCase();
  const filtered = referrals.filter(
    (row) =>
      row.name?.toLowerCase().includes(query) ||
      row.email?.toLowerCase().includes(query),
  );

  return isMobile ? (
    <CustomTableMobile
      hidePagination
      isLoading={isLoading}
      isInitialized={!isLoading}
      search={search}
      data={filtered}
    >
      {filtered.map((row) => (
        <div
          key={row.referral_user_id}
          onClick={() => openReferralInfoDialog(row)}
          className="tableMobile__list-item referralsMobile__item"
        >
          <div className="referralsMobile__item-left">
            <p className="fw-500">{row.name}</p>
            <p className="secondary-text">{row.email}</p>
          </div>
          <div className="referralsMobile__item-right">
            <ReferralRevenue row={row} />
            <ReferralDaysLeft days={row.expireDays} />
          </div>
        </div>
      ))}
    </CustomTableMobile>
  ) : (
    <CustomTable
      hidePagination
      isLoading={isLoading}
      isInitialized={!isLoading}
      search={search}
      columns={referralsColumns}
      data={filtered}
    >
      {filtered.map((row) => (
        <TableRow tabIndex={-1} key={row.referral_user_id}>
          <TableCell>
            <p>{row.name}</p>
            <p className="secondary-text">{row.email}</p>
          </TableCell>
          <TableCell>
            <ReferralDaysLeft days={row.expireDays} />
            <p className="secondary-text">{formatMonth(row.created_at)}</p>
          </TableCell>
          <TableCell align="right">{row.rate}%</TableCell>
          <TableCell align="right">
            <ReferralRevenue row={row} />
          </TableCell>
        </TableRow>
      ))}
    </CustomTable>
  );
}
